//export const webUrl = 'http://sever.frp.gie360.com/oms';
export const webUrl = 'http://api.55train.com/oms';
//export const webUrl = 'http://localhost:7001/oms';